module.exports = __webpack_public_path__ + "static/img/jchb1-2.ff6def8.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/layout/jchb1-2.png
// module id = 760
// module chunks = 0